var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleLogoSeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9895 10.1868C19.9895 9.36742 19.9214 8.76949 19.7742 8.14941H10.1992V11.8477H15.8195C15.7062 12.7668 15.0943 14.1509 13.7346 15.081L13.7155 15.2048L16.7429 17.4966L16.9527 17.5171C18.879 15.7786 19.9895 13.2208 19.9895 10.1868Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1983 19.9313C12.9517 19.9313 15.2633 19.0454 16.9517 17.5174L13.7336 15.0812C12.8724 15.6681 11.7166 16.0778 10.1983 16.0778C7.50143 16.0778 5.21253 14.3394 4.3966 11.9365L4.277 11.9464L1.12906 14.3272L1.08789 14.439C2.7649 17.6945 6.20961 19.9313 10.1983 19.9313Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39845 11.9363C4.18316 11.3163 4.05857 10.6518 4.05857 9.96534C4.05857 9.27878 4.18316 8.61443 4.38713 7.99435L4.38142 7.86229L1.19402 5.44336L1.08973 5.49183C0.398553 6.84275 0.00195312 8.35977 0.00195312 9.96534C0.00195312 11.5709 0.398553 13.0879 1.08973 14.4388L4.39845 11.9363Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1983 3.85334C12.1133 3.85334 13.405 4.66166 14.1416 5.33716L17.0197 2.59106C15.2521 0.985493 12.9518 0 10.1983 0C6.20964 0 2.76491 2.23671 1.08789 5.49212L4.3853 7.99463C5.21256 5.59181 7.50147 3.85334 10.1983 3.85334Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogoSeo);
export default __webpack_public_path__ + "static/media/google_logo_seo.57cc80f89a8cffecce1aa635ae637e42.svg";
export { ForwardRef as ReactComponent };